import App from 'App';
import IchiVaultContainer from 'containers/IchiVaultContainer';
import React from 'react';
import { Router } from '@reach/router';
import VaultInfoContainer from 'containers/VaultInfoContainer';
import TreasuryTableContainer from 'containers/TreasuryTableContainer';
import MintRedeemContainer from 'containers/MintRedeemContainer';
import VaultsByBaseTokenContainer from 'containers/VaultsByBaseTokenContainer';
import ErrorContainer from 'containers/ErrorContainer';

const Index: React.FC = () => {
  return (
    <>
      <base href="/" />
      <App>
        <Router basepath="/">
          <IchiVaultContainer path="/" />
          <VaultsByBaseTokenContainer path="vault" />
          <VaultsByBaseTokenContainer path="vault/token/:token" />
          <VaultsByBaseTokenContainer path="vault/token/:token/pairedtoken/:pairedtoken" />
          <VaultsByBaseTokenContainer path="vault/token/:token/pairedtoken/:pairedtoken/tab/:tab" />
          <VaultsByBaseTokenContainer path="vault/address/:address" />
          <VaultInfoContainer path="vaultinfo" />
          <TreasuryTableContainer version={2} path="treasury" />
          <MintRedeemContainer path="mint" />
          <ErrorContainer default />
        </Router>
      </App>
    </>
  );
};

export default Index;
